.nest-theme-switcher {
  @apply flex p-3 hover:bg-foreground/5 rounded hover:cursor-pointer;

  nest-icon {
    @apply w-4 h-4;
  }
}





